import React, { useRef } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import { FiChevronRight } from "react-icons/fi";
import ExperienceCard from "../vendors/ExperienceCard";

// Skeleton card for loading state
const ExperienceCardSkeleton = () => (
  <div className="bg-white rounded-xl overflow-hidden shadow-sm border border-gray-100 animate-pulse">
    <div className="h-48 bg-gray-200"></div>
    <div className="p-4">
      <div className="h-3 w-20 bg-gray-200 rounded mb-2"></div>
      <div className="h-4 w-full bg-gray-200 rounded mb-2"></div>
      <div className="h-4 w-3/4 bg-gray-200 rounded mb-3"></div>
      <div className="flex justify-between items-center">
        <div className="h-5 w-16 bg-gray-200 rounded"></div>
        <div className="h-3 w-12 bg-gray-200 rounded"></div>
      </div>
    </div>
  </div>
);

const TopExperience = ({
  title = "Top Experiences",
  description = "Quality as judged by customers. Book at the ideal price!",
  experiences = [],
  isLoading = false,
  onExperienceClick,

  showDescription = true,
  showViewAll = false, // ✅ NEW
  onViewAllClick, // ✅ NEW
}) => {
  const swiperRef = useRef(null);

  const handleNext = () => {
    swiperRef.current?.slideNext();
  };

  return (
    <div className="container mx-auto px-2 lg:px-12 pt-6 md:pt-10">
      <h2 className="text-[#000000] font-bold text-2xl md:text-3xl">{title}</h2>

      {/* 🔥 Description + View All (independent) */}
      {(showDescription || showViewAll) && (
        <div className="flex items-center justify-between pt-1 md:pt-3">
          {showDescription ? (
            <p className="text-[16px] md:text-lg text-[#242424]">
              {description}
            </p>
          ) : (
            <div /> // left empty spacer
          )}
        </div>
      )}

      {showDescription && (
        <div className="mt-3 h-1 w-[40%] md:w-[20%] lg:w-[11%] bg-[#1FADC6]"></div>
      )}

      <div className="prodcut-listing py-4 md:py-8">
        {showViewAll && (
          <div className="flex justify-end mt-2 md:mt-4">
            <button
              onClick={onViewAllClick}
              className="
                text-[#1FADC6]
                text-sm md:text-base
                font-medium
                bg-transparent
                hover:underline
                transition
              "
            >
              View All
            </button>
          </div>
        )}
        <div className="products pt-4 md:pt-8 relative">
          {isLoading ? (
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-5">
              {[...Array(5)].map((_, i) => (
                <ExperienceCardSkeleton key={i} />
              ))}
            </div>
          ) : experiences.length > 0 ? (
            <>
              <Swiper
                modules={[Pagination, Navigation]}
                spaceBetween={20}
                slidesPerView={1.2}
                loop={experiences.length > 4}
                pagination={{ clickable: true }}
                onSwiper={(swiper) => (swiperRef.current = swiper)}
                breakpoints={{
                  375: { slidesPerView: 1.5 },
                  640: { slidesPerView: 2.2 },
                  768: { slidesPerView: 3 },
                  1024: { slidesPerView: 4 },
                  1280: { slidesPerView: 5 },
                  1536: { slidesPerView: 4, spaceBetween: 16 },
                }}
                className="top-exp-slider pb-[45px] "
              >
                {experiences.map((item) => (
                  <SwiperSlide key={item.experienceId}>
                    <div onClick={() => onExperienceClick?.(item.experienceId)}>
                      <ExperienceCard
                        id={item.experienceId}
                        img={item.imageUrl}
                        location={item.location}
                        title={item.title}
                        price={item.priceFrom}
                        time={item.duration}
                        rating={item.ratingAvg}
                        tag="Experience"
                      />
                    </div>
                  </SwiperSlide>
                ))}
              </Swiper>

              {/* Right Arrow */}
              {experiences.length > 4 && (
                <button
                  onClick={handleNext}
                  className="
                    absolute right-0 top-1/2 -translate-y-1/2 -translate-x-4
                    z-10 h-12 w-12 flex items-center justify-center
                    bg-white border border-[#E5E7EB] rounded-full
                    shadow-lg hover:bg-gray-50 hover:shadow-xl
                    transition-all duration-300 group
                  "
                >
                  <FiChevronRight
                    size={24}
                    className="text-gray-700 group-hover:text-[#1FADC6]"
                  />
                </button>
              )}
            </>
          ) : (
            <p className="text-gray-500 text-center py-8">
              No experiences available
            </p>
          )}
        </div>
      </div>
    </div>
  );
};

export default TopExperience;
